import React from 'react';
import BusinessProfileWidget from './BusinessProfileWidget';

const BusinessProfileWidgetBasic = () => (
  <BusinessProfileWidget className="masonry-item w-[440px] h-[300px] flex flex-col" />
);

export default BusinessProfileWidgetBasic;
